export default __webpack_public_path__ + "static/media/faviconBje.0a547a42.ico";